import VerifiedBadge from "../../../../components/VerifiedBadge";
import { JobApplication } from "../model/JobModel";

interface ApplicationCardProps {
  applications: JobApplication;
  onView: () => void;
  onContact?: () => void;
}

export function ApplicationGridCard({
  applications,
  onView,
  onContact,
}: ApplicationCardProps) {
  const isVerified =
    applications.candidate.is_identity_verified === true ||
    applications.candidate.is_id_verified === true;

  const getStatusColor = (status: string) => {
    switch (status) {
      case "New":
        return "bg-blue-100 text-blue-700";
      case "Reviewing":
        return "bg-yellow-100 text-yellow-700";
      case "Interview Scheduled":
        return "bg-purple-100 text-purple-700";
      case "Offered":
        return "bg-green-100 text-green-700";
      case "Rejected":
        return "bg-red-100 text-red-700";
      case "Hired":
        return "bg-emerald-100 text-emerald-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow">
      {/* Header */}
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 className="text-sm font-medium text-gray-900 truncate">
            {applications.candidate.current_job_title || "No Title"}
          </h2>
          {isVerified && (
            <span className="mt-1 inline-flex">
              <VerifiedBadge />
            </span>
          )}
        </div>

        <span
          className={`shrink-0 px-2 py-0.5 text-[11px] rounded-full font-medium ${getStatusColor(
            applications.status,
          )}`}
        >
          {applications.status.replace("_", " ")}
        </span>
      </div>

      {/* Experience */}
      <div className="flex items-center gap-1 text-xs mt-1">
        <p className="text-xs text-gray-600">
          💼 {applications.candidate.years_of_experience} years exp.
        </p>
      </div>

      {/* Footer */}
      <div
        className={`flex mt-2 ${
          applications.contact_unlocked ? "space-x-2" : "justify-end"
        }`}
      >
        {applications.contact_unlocked && (
          <button
            onClick={onContact}
            className="flex-1 text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded hover:bg-gray-200"
          >
            Contact
          </button>
        )}

        <button
          onClick={onView}
          className={`text-xs bg-indigo-600 text-white px-3 py-1 rounded hover:bg-indigo-700
      ${applications.contact_unlocked ? "flex-1" : ""}
    `}
        >
          View
        </button>
      </div>
      {/* <div className="mt-2 flex justify-end">
        {applications.contact_unlocked == true ? (
          <>
            <button
              // onClick={onView}
              className="w-[10vh] text-xs bg-indigo-600 text-white px-2 py-1 rounded hover:bg-indigo-700"
            >
              contact
            </button>
            <button
              onClick={onView}
              className="w-[10vh] text-xs bg-indigo-600 text-white px-2 py-1 rounded hover:bg-indigo-700"
            >
              View
            </button>
          </>
        ) : (
          <button
            onClick={onView}
            className="w-[10vh] text-xs bg-indigo-600 text-white px-2 py-1 rounded hover:bg-indigo-700"
          >
            View
          </button>
        )}
      </div> */}
    </div>
  );
}
